import { Alert, Button, Center, Group, Paper, PinInput, Stack, Text, Title } from '@mantine/core';
import { IconShieldLock } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { api, podatki } from '../api/odjemalec';
import { NapakaApi, sporocilo } from '../api/napaka';
import { barve } from '../tema';
import { skrbniskiZeton } from './zeton';

/**
 * Drugi korak vstopa v skrbništvo: koda iz aplikacije za preverjanje (TOTP). Ob šesti števki se pošlje sama; napačne
 * kode strežnik po nekaj poskusih začasno zaklene. Ob prikazu najprej poskusi vstop brez kode: uspe samo na lokalnem
 * strežniku s hera.skrbnik.brez-kode=true, sicer ga strežnik zavrne (ne šteje kot napačna koda) in ostane vnos kode.
 */
export function Vstop() {
  const [koda, setKoda] = useState('');
  const [napaka, setNapaka] = useState<string | null>(null);
  const [dela, setDela] = useState(false);
  // po napačni kodi se polje na novo izriše, da je fokus spet na prvi števki
  const [poskus, setPoskus] = useState(0);

  useEffect(() => {
    let preklicano = false;
    podatki(api.POST('/api/skrbnik/vstop', { body: { koda: '' } }))
      .then((o) => {
        if (!preklicano) {
          skrbniskiZeton.nastavi(o.zeton ?? null);
        }
      })
      .catch(() => {});
    return () => {
      preklicano = true;
    };
  }, []);

  const poslji = async (k: string) => {
    setNapaka(null);
    setDela(true);
    try {
      const o = await podatki(api.POST('/api/skrbnik/vstop', { body: { koda: k } }));
      skrbniskiZeton.nastavi(o.zeton ?? null);
    } catch (e) {
      setNapaka(e instanceof NapakaApi ? (e.polja.koda ?? e.message) : sporocilo(e));
      setKoda('');
      setPoskus((n) => n + 1);
    } finally {
      setDela(false);
    }
  };

  return (
    <Center py={60}>
      <Paper radius="lg" p={{ base: 'lg', sm: 36 }} shadow="md" maw={420} w="100%">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            void poslji(koda);
          }}
        >
          <Stack gap="md" align="center">
            <IconShieldLock size={40} color={barve.primarna} />
            <Title order={1} size="h3" ta="center">
              Skrbništvo
            </Title>
            <Text size="sm" c="dimmed" ta="center">
              Vpišite 6-mestno kodo iz aplikacije za preverjanje (Authenticator).
            </Text>
            <PinInput
              key={poskus}
              length={6}
              type="number"
              oneTimeCode
              autoFocus
              size="lg"
              value={koda}
              onChange={setKoda}
              onComplete={(k) => void poslji(k)}
              error={!!napaka}
              disabled={dela}
              ariaLabel="Koda za preverjanje"
            />
            {napaka && (
              <Alert color="red" variant="light" role="alert" w="100%">
                {napaka}
              </Alert>
            )}
            <Group>
              <Button type="submit" loading={dela} disabled={koda.length !== 6}>
                Vstopi
              </Button>
            </Group>
          </Stack>
        </form>
      </Paper>
    </Center>
  );
}
